import { Api } from "./api";
import { SearchOptions } from "src/models/SearchOptions";

export class URLBuilder {
    
    public static author_combined_trend(author_id: string, start: number, end: number){
        return `${Api.getEndPoint()}/author-combined-trend/${author_id}?start=${start}&end=${end}`
    }

    public static login() {
        return `${Api.getEndPoint()}/login`;
    }

    public static user_info() {
        return `${Api.getEndPoint()}/user-info`;
    }

    public static faculty_list(index: string) {
        return `${Api.getEndPoint()}/faculty-list?index=${index}`
    }

    public static basic_details(faculty_id: number) {
        return `${Api.getEndPoint()}/basic-details/${faculty_id}`
    }

    public static logout() {
        return `${Api.getEndPoint()}/logout`
    }

    public static college_filter_tree() {
        return `${Api.getEndPoint()}/college-filter-tree` ;
    }

    public static aggregate_college() {
        return `${Api.getEndPoint()}/aggregate-college`
    }

    public static aggregate_department(entity_id: number) {
        return `${Api.getEndPoint()}/aggregate-department/${entity_id}`
    }

    public static aggregate_faculty(entity_id: number) {
        return `${Api.getEndPoint()}/aggregate-faculty/${entity_id}`
    }

    public static awards_over_time(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/awards-over-time/${faculty_id}?start=${start}&end=${end}`
    }

    public static awards_by_fundingagency(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/awards-by-fundingagency/${faculty_id}?year=${year}`
    }

    public static awards_by_fundingagency_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/awards-by-fundingagency/${faculty_id}?start=${start}&end=${end}`
    }

    public static awards_by_department(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/awards-by-department/${faculty_id}?year=${year}`
    }

    public static awards_by_department_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/awards-by-department/${faculty_id}?start=${start}&end=${end}`
    }

    public static awards_for_faculty(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/awards-for-faculty/${faculty_id}?year=${year}`
    }

    public static awards_for_faculty_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/awards-for-faculty/${faculty_id}?start=${start}&end=${end}`
    }

    public static expenditure_over_time_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/expenditure-over-time/${faculty_id}?start=${start}&end=${end}`
    }

    public static expenditure_by_project(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/expenditure-by-project/${faculty_id}?year=${year}`
    }

    public static expenditure_by_project_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/expenditure-by-project/${faculty_id}?start=${start}&end=${end}`
    }

    public static expenditure_by_department(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/expenditure-by-department/${faculty_id}?year=${year}`
    }

    public static expenditure_by_department_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/expenditure-by-department/${faculty_id}?start=${start}&end=${end}`
    }

    public static project_info(project_id: string) {
        return `${Api.getEndPoint()}/project-info/${project_id}`
    }

    public static proposals_over_time(faculty_id: string) {
        return `${Api.getEndPoint()}/proposals-over-time/${faculty_id}`
    }
    
    public static proposals_over_time_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/proposals-over-time/${faculty_id}?start=${start}&end=${end}`
    }

    public static proposals_by_fundingagency(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/proposals-by-fundingagency/${faculty_id}?year=${year}`
    }

    public static proposals_by_fundingagency_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/proposals-by-fundingagency/${faculty_id}?start=${start}&end=${end}`
    }

    public static proposals_by_department(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/proposals-by-department/${faculty_id}?year=${year}`
    }

    public static proposals_by_department_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/proposals-by-department/${faculty_id}?start=${start}&end=${end}`
    }

    public static proposals_for_faculty(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/proposals-for-faculty/${faculty_id}?year=${year}`
    }

    public static proposals_for_faculty_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/proposals-for-faculty/${faculty_id}?start=${start}&end=${end}`
    }

    public static author_publications_combined_view(faculty_id: string, year: number) {
        return `${Api.getEndPoint()}/author-publications-combined-view/${faculty_id}?year=${year}`
    }

    public static author_publications_combined_view_for_range(faculty_id: string, start: number, end: number) {
        return `${Api.getEndPoint()}/author-publications-combined-view/${faculty_id}?start=${start}&end=${end}`
    }

    public static source_info(source_id: string) {
        return `${Api.getEndPoint()}/source-info/${source_id}`;
    }

    public static subject_area_info(subject_area_id: string) {
        return `${Api.getEndPoint()}/subject-area-info/${subject_area_id}`
    }

    public static author_info(author_id: string) {
        return `${Api.getEndPoint()}/author-info/${author_id}`
    }

    public static search(searchOptions: SearchOptions) {
        const searchOptionsStr = JSON.stringify(searchOptions);
        return `${Api.getEndPoint()}/search/?options=${searchOptionsStr}`
    }

    public static current_pending(author_id: string){
        return `${Api.getEndPoint()}/current-pending/${author_id}?type=${"generic"}`
    }

    public static funding_agency(){
        return `${Api.getEndPoint()}/funding-agency`
    }


}


// WEBPACK FOOTER //
// ./src/core/URLBuilder.ts